import React, { useState } from "react";
import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import Button from "../../UI/Button/Button";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

import LogService from "../../../middleware/CommonSdk/LogService";
import { getTimeStamp } from "../../../middleware/Utils/DateUtils";

const LOG_TAG = "LOGS";

const Logs = (props) => {
    const intl = useIntl();

    const [logLevel, setLogLevel] = useState(LogService.getCurrentLogLevel().toString());
    const [progress, setProgress] = useState(false);

    const logLevelChangeHandler = (event) => {
        LogService.info(LOG_TAG, "Log level Changed:", event.target.value);
        LogService.setLevel(event.target.value);
        setLogLevel(event.target.value);
    };

    const sendButtonClickHandler = () => {
        LogService.info(LOG_TAG, "sendButtonClickHandler");
        setProgress(true);
        LogService.getLogFiles().then((blobContent) => {
            LogService.info(LOG_TAG, "sendButtonClickHandler got log file");
            const filename = "RainbowHub_LogFile_" + getTimeStamp() + ".zip";
            saveFileToDownloadDirectory(filename, blobContent);
            setProgress(false);
        });
    }

    // const openMail = (fileLink) => {
    //     var link = "mailto:" + MAIL_DESTINATION
    //         // + "?cc=myCCaddress@example.com"
    //         + "?subject=" + encodeURIComponent("Rainbow hub log file from ") + getTimeStamp()
    //         + "&body=" + encodeURIComponent("Naviguer dans votre répertoire \"Téléchargement\" et veuillez attacher le fichier : \"" + fileLink + "\"\n\n\"http://localhost.com\"\n\n");
    //     window.location.href = link;
    // }

    const saveFileToDownloadDirectory = (filename, content) => {
        const atag = document.createElement("a");
        const file = new Blob([content], { type: "text/plain" });
        atag.href = URL.createObjectURL(file);
        atag.download = filename;
        document.body.appendChild(atag); // Required for this to work in FireFox
        atag.style.display = "none";
        atag.click();
        document.body.removeChild(atag);
        URL.revokeObjectURL(atag.href);
    }

    LogService.info(LOG_TAG, "render");

    let logLevelListOptions = Object.values(LogService.getAllLevels()).map((value) => {
        return (
            <option value={value.toString()} key={value.toString()}>
                {value.toString()}
            </option>
        );
    });

    return (
        <Card title={intl.messages.logLevel}>
            <div className="form-group">
                <label className="input-label">{intl.messages.logLevelTitle}</label>
                <select className="form-control mb-1"
                    value={logLevel}
                    onChange={logLevelChangeHandler}>
                    {logLevelListOptions}
                </select>
            </div>
            
            <Button
                label={intl.messages.sendlogByEmailTitle}
                icon={faEnvelope}
                className="btn-submit"
                onClick={sendButtonClickHandler}
                spinner={progress}
                disabled={progress}
            />
        </Card >
    );
}

export default Logs;